import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from "rxjs";
import { AdjustmentModel } from '../models/adjustment.model';
import { AdjustmentAccountPeriodModel } from '../models/adjustmentAccountPeriod.model';
import { InfraService } from './infra.service';

@Injectable()
export class AdjustmentService {
  private coreAPIUrl: string;

  constructor(private infraService: InfraService, private http: HttpClient) {
    this.infraService.infraDetails$.subscribe(data => {
      this.coreAPIUrl = data.WebEndPoint2 + 'adjustment';
    });

    if (!this.infraService.isInfraDetailsAvailable && localStorage.getItem('selectedInfra') != undefined) {
      this.infraService.isInfraDetailsAvailable = true;
      this.infraService.setInfraDetails(localStorage.getItem('selectedInfra'));
    }
  }

  public getAdjustments(engagementId: number): Observable<AdjustmentModel[]> {
    return this.http.get<AdjustmentModel[]>(`${this.coreAPIUrl}/getAdjustmentByEngId/${engagementId}`);
  }

  public getAdjustment(adjustmentId: number): Observable<AdjustmentModel> {
    return this.http.get<AdjustmentModel>(`${this.coreAPIUrl}/getAdjustment/${adjustmentId}`);
  }

  public save(adjustmentData: AdjustmentModel) {
    return this.http.post(`${this.coreAPIUrl}/CreateAdjustment`, adjustmentData);
  }

  public update(adjustmentData: AdjustmentModel) {
    return this.http.post(`${this.coreAPIUrl}/updateAdjustment/${adjustmentData.id}`, adjustmentData);
  }

  public deleteSelectedAdjustment(engagementId: number, selectedAdjustments: AdjustmentModel[]) {
    return this.http.post(`${this.coreAPIUrl}/deleteSelectedAdjustment/${engagementId}`, selectedAdjustments);
  }

  public downloadAdjusmentTemplate(engagementId: number) {
    return this.http.get(`${this.coreAPIUrl}/DownloadAdjustmentTemplate/${engagementId}`, {
      responseType: 'arraybuffer'
    });
  }

  public getAdjustmentAccountPeriod(adjustmentId: number, engagementId: number): Observable<AdjustmentAccountPeriodModel[]> {
    return this.http.get<AdjustmentAccountPeriodModel[]>(`${this.coreAPIUrl}/getAdjustmentAccountPeriod/${adjustmentId}/${engagementId}`);
  }

  private handleError(error: Response) {
    return throwError(()=> error);
  }
}
